import { useMasterDataDistributionCenters } from "@src/presentation/providers/MasterDataDistributionCentersDataProvider";
import { MasterDataListFooter } from "./MasterDataListFooter";

export const MasterDataDistributionCentersFooter = () => {
  const { total, page, limit, loading, setPage } =
    useMasterDataDistributionCenters();

  return (
    <MasterDataListFooter
      total={total}
      page={page}
      limit={limit}
      loading={loading}
      onPageChange={setPage}
      ariaLabel="Distribution Centers Pagination"
    />
  );
};
